import { serviceNameValues } from './common';

export default [
  {
    value: serviceNameValues.BUILD_YOUR_DREAM_SITE,
    iconGlyph: 'brush',
    title: 'Build your dream site',
    description: 'Get a brand-new website built from scratch with Yola Sitebuilder+',
  },
  {
    value: serviceNameValues.REVAMP_YOUR_WEBSITE,
    iconGlyph: 'sparkles',
    title: 'Revamp your website',
    description: 'Get the website you’ve already built enhanced and refined',
  },
  {
    value: serviceNameValues.MIGRATE_YOUR_SITE_TO_YOLA,
    iconGlyph: 'repeat',
    title: 'Migrate your site to Yola',
    description: 'Get your existing website rebuilt on Yola Sitebuilder+',
  },
];
